<template>
  <div></div>
</template>

<route lang="json">
{
  "name": "zi",
  "meta": { "fullWidth": true }
}
</route>

<script setup lang="ts">
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

onMounted(() => {
  router.push({ name: "zi-2024" });
});
</script>

<style scoped></style>
